import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { CompanyGridDataService } from 'common/services/data-services/admin/internship-company/company-grid-data.service';
import { DocumentReportsModel } from 'common/models/page-models/reports/document-reports/document-report-data-model';
import { DocumentReportsListingModel } from 'common/models/page-models/reports/document-reports/document-report-grid-model';
import { DocumentReportsDataService } from 'common/services/data-services/admin/reports/document-reports.service';
import { DocumentReportsGridMetaModel } from 'common/models/page-models/reports/document-reports/document-report-grid-meta.model';
import { documentListDataService } from 'common/services/data-services/custom-service/documentlist-service';
import { SEMESTER_OPTIONS, YEAR_OPTIONS } from 'common/constants/sm-constants';


@Injectable({
    providedIn: 'root'
})
export class DocumentReportsWidgetService extends GridWidgetService<DocumentReportsModel, DocumentReportsListingModel> {
    constructor(protected override  ds: DocumentReportsDataService, protected systemService: SystemService, private batchListService: BatchListDataService, private branchListService: branchListDataService, private stateService: stateListDataService, private companyListService: CompanyGridDataService, private documentTypeService: documentListDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new DocumentReportsGridMetaModel().getMetaModel();
        return meta;
    }

     override prepareMetaModel(dataModel: DocumentReportsListingModel, metaModel: DocumentReportsGridMetaModel, routeData: WidgetModel, event: any = null, value: any = null): Promise<DocumentReportsGridMetaModel> {
        return new Promise<DocumentReportsGridMetaModel>((resolve, reject) => {
          
                this.batchListService.postData('').then((data) =>{
                    metaModel.filterMeta.properties.selectedBatch.options = data.details;
                });
                this.branchListService.postData('').then((data) =>{
                    metaModel.filterMeta.properties.selectedBranch.options = data.details;
                });
                this.stateService.postData('').then((data) =>{
                    metaModel.filterMeta.properties.selectedState.options = data.details;
                });
           
           
           
            resolve(metaModel);
        });
    }

}